import { Form, useFormikContext } from 'formik';
import { MapSessionFormFields, SectionContainerContent, YesNoRadioControl } from '../../components';
import { ClinicalNotesFormType } from '../../types';
import { useSectionStyles } from '../styles';
import clsx from 'clsx';
import { dynamicFormVisibilityMapping } from '../../helpers';
import { useL10n } from '@uplift/hooks';

export const MentalStatusExam: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useSectionStyles();
  const formik = useFormikContext<ClinicalNotesFormType>();

  const showForm = formik.values.mentalStatusExamWithinNormalRangeYesNo === dynamicFormVisibilityMapping.mentalStatusExam.visibleOnYesNoValue;

  return (
    <>
      <SectionContainerContent>
        <YesNoRadioControl
          label={l10n.clinicalNotes.allWithinNormalRange}
          baseName="mentalStatusExamWithinNormalRange"
        />
      </SectionContainerContent>
      {showForm && (
        <SectionContainerContent className={classes.greyBackground}>
          <Form className={clsx([ classes.formGroup, classes.gap2 ])}>
            <MapSessionFormFields namespace="mentalStatusExam" />
          </Form>
        </SectionContainerContent>
      )}
    </>
  );
};
